import React from "react";

// Several of the RPCs behind this page are NOT modality-scoped — they reject a
// `p_modality` argument outright (PGRST202), so they answer for chat and phone
// together:
//
//   fn_get_agent_value          → chat_recovery, chat_deflection
//   fn_get_conversation_summary → chat_demand, chat_barriers, chat_attribution
//   fn_get_knowledge_gaps       → chat_website_gaps
//
// For Verde Ranch that is 100 phone calls behind every 66 chats — a clear
// majority of the figures on those panels. The numbers look plausible while
// being about a different channel than the page's title implies, which is the
// worst combination available: the frozen summary payload carries
// `outcomes.voicemail_left: 4`, an outcome no chat window can produce.
//
// The frontend cannot fix that — Part F forbids computing, and there is no
// modality-scoped alternative to call. What it can do is say so where the
// number is, every time, in one wording. Silence would let an owner read a
// phone figure as a chat figure.
export const CROSS_CHANNEL_NOTE =
  "Counts chat and phone together — this figure is not split by channel.";

/** The disclosure line. Renders nothing when the panel is not cross-channel. */
const CrossChannelNote = ({ when = true, className = "mt-2" }) => {
  if (!when) return null;
  return (
    <p className={`gi-body text-gray-500 dark:text-gray-400 ${className}`}>
      {CROSS_CHANNEL_NOTE}
    </p>
  );
};

export default CrossChannelNote;
